import { __rest, __assign } from './../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from 'classnames';
import styles from './ChoiceCard.module.css.js';

var ChoiceCard = function (_a) {
    var _b;
    var selected = _a.selected, disabled = _a.disabled, className = _a.className, testId = _a.testId, children = _a.children, onClick = _a.onClick, marmaladeBase = __rest(_a, ["selected", "disabled", "className", "testId", "children", "onClick"]);
    var classes = classNames(styles.root, (_b = {},
        _b[styles.disabled] = disabled,
        _b[styles.selected] = selected,
        _b[styles.clickable] = !!onClick,
        _b), className);
    return (React__default.createElement("div", __assign({ role: "presentation", className: classes, "data-testid": testId, onClick: onClick }, marmaladeBase), children));
};

export { ChoiceCard };
//# sourceMappingURL=ChoiceCard.js.map
